import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from 'enumify-ts';
class ChecklistType extends Enumify() {
    description;
    multiplesSupported;
    mandatesChecks;
    rejectable;
    static LOAD = new ChecklistType("Load", false, true, false);
    static VEHICLE = new ChecklistType("Vehicle", false, true, false);
    static DELIVERY = new ChecklistType("Delivery", false, true, false);
    static CONTRACTOR_ONBOARDING = new ChecklistType("Contractor Onboarding", true, false, true);
    static EMPLOYEE_DRIVER_INDUCTION = new ChecklistType("Employee Driver Induction", true, false, true);
    static _ = ChecklistType._closeEnum();
    constructor(description, multiplesSupported, mandatesChecks, rejectable) {
        super();
        this.description = description;
        this.multiplesSupported = multiplesSupported;
        this.mandatesChecks = mandatesChecks;
        this.rejectable = rejectable;
    }
    renderTag() {
        return _jsx(Tag, { children: this.description });
    }
    static selectOptionsArray() {
        return ChecklistType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
    static filtersArray() {
        return ChecklistType.values.map(t => {
            return { text: t.description, value: t.key };
        });
    }
}
export default ChecklistType;
